import React from 'react';
import molecules from 'ctsutheme/components/molecules';
import atoms from 'ctsutheme/components/atoms';
import PropTypes from 'prop-types';
import Contact from './ViewContact';

const { Typography } = atoms;
const { List, ListSubHeader } = molecules;

const PIContact = ({
  pi
}) => (
  <List
    subheader={(
      <ListSubHeader flex>
        <Typography data-id="piContactTitle" inline primary>
          PI Contact
        </Typography>
      </ListSubHeader>
          )}
  >
    <Contact data={pi || {}} />
  </List>
);

PIContact.propTypes = {
  pi: PropTypes.oneOfType([PropTypes.object])
};

PIContact.defaultProps = {
  pi: null
};

export default PIContact;
